/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

// import { IoClipboard } from "react-icons/io5";
import Loading from "../../common/Loading";
import PROJECT_COLUMNS from "./columns";
import ResponsiveDataComponent from "../../common/ResponsiveDataComponent";

import {
  /* ProjectStatusBadge, */ Favorite
  /*  ProjectProgress */
} from "./components";
// import TableActions from "../../common/TableActions";

// const getAssignView = (isMobile, isAssigned) => {
//   if (isMobile) {
//     return (
//       <IoClipboard style={{ color: "#50accb" }} />
//     );
//   }
//   if (!isAssigned) {
//     return "ASSIGN";
//   }
//   return "VIEW";
// };

import { formatDate } from "../../../helpers/date";

const ProjectList = ({
  data,
  loading,
  sorted,
  page,
  maxListHeight,
  pageSize,
  pages,
  onPageSizeChange,
  onPageChange,
  onSortedChange,
  isMobile,
  onRowClick = () => {},
  isFavoriteToggable
}) => {
  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }
  const mobileColumns = [
    {
      Header: <Favorite value toggleable={false} />,
      headerClassName: "flex -center-h",
      accessor: "isFavorite",
      id: "favorites",
      Cell: ({ value, row }) => (
        <Favorite value={value} row={row} toggleable={isFavoriteToggable} />
      ),
      sortable: false,
      minWidth: 50,
      maxWidth: 50
    },
    {
      Header: "Project Name",
      accessor: "name"
    }
  ];

  const props = {
    getTdProps: (state, rowInfo, column) => {
      if (!column.expander) {
        return {
          onClick: () => {
            if (column.id !== "favorites") {
              onRowClick(rowInfo);
            }
          }
        };
      }
      return {};
    }
  };

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        {...props}
        className="-highlight"
        style={{ maxHeight: maxListHeight }}
        columns={isMobile ? mobileColumns : PROJECT_COLUMNS}
        data={data}
        manual
        sorted={sorted}
        pages={pages}
        page={page}
        pageSize={Math.min(data.length, pageSize)}
        showPagination={pages > 1}
        showPageSizeOptions={!isMobile}
        onSortedChange={onSortedChange}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        SubComponent={
          isMobile
            ? ({ original }) => (
                <ResponsiveDataComponent
                  data={[
                    { key: "Status", label: original.status },
                    { key: "Project Manager", label: original.projectManager },
                    { key: "Customer", label: original.customer },
                    { key: "Call Type", label: original.callType },
                    {
                      key: "Start Date",
                      label: formatDate(original.start_date, "MM/dd/yyyy")
                    }
                  ]}
                />
              )
            : false
        }
      />
      {/* <pre>
        <code>{JSON.stringify(data, null, 2)}</code>
      </pre> */}
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
ProjectList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  sorted: PropTypes.array,
  onSortedChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onRowClick: PropTypes.func,
  page: PropTypes.number,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  isMobile: PropTypes.bool,
  isFavoriteToggable: PropTypes.bool
};

ProjectList.defaultProps = {
  isFavoriteToggable: true
};

export default ProjectList;
